import { Tooltip } from "@mui/material";
import React from "react";
import moment from "moment";
import LocationPointIcon from "assets/svgIcons/ShareIcon";
import CloseIcon from "assets/svgIcons/ModalCloseOutIcon";
import { HoverWindow } from "commonComponents/HoleUI/CarsOnCourseStyled";
import SignalIcon from "assets/svgIcons/SignalIcon";
import { useSelector } from "react-redux";
import { reasonForReportString, controlType } from "constant";
import { useHookstate } from "@hookstate/core";
import { CAR_LOCATION_STATE, MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { deviceType } from "_helperFunctions/deviceType";
import { useCarSettingsData } from "_helperFunctions/carSettings";

export const HistoryIconPopup = (props) => {
  const { t } = useTranslation();
  const { siteSettingsData } = useSelector((state) => state.commonReducers) || [];
  const { showTaggedCar, specificCarTrackHistory } =  useHookstate(MAP_GLOBAL_STATES);
  const { carLocationBtn } = useHookstate(CAR_LOCATION_STATE);
  const { isSiteUsingYards, convertMileToKM } = useCarSettingsData();

  function hideLocation() {
    showTaggedCar.set(null);
    specificCarTrackHistory.set(false);
    carLocationBtn.set(false);

    let locationTrackingData = {
      carNumber: null,
      gpsiCarId: null,
      carType: null,
    };

    locationTrackingData = JSON.stringify(locationTrackingData);
    localStorage.setItem("locationTrackingData", locationTrackingData);
  }

  const getOdometerDisplay = () => {
    if (!props.carProductData) return "";

    const odometerBase = props.clickState?.data?.GPSOdometerBase ?? 0;
    let odometer;
    
    if (
      props.carProductData.CarHistoryOdometer !== null &&
      props.carProductData.CarHistoryOdometer !== undefined &&
      props.carProductData.CarHistoryOdometer !== 0
    ) {
      odometer = props.carProductData.CarHistoryOdometer;
    } else if (props.carProductData.DevType === deviceType.FT2) {
      odometer = props.carProductData.Odometer;
    } else if (!props.clickState?.data?.CanCarCommunicate) {
      odometer = props.carProductData.GPSOdometer;
    } else {
      odometer = props.carProductData.Odometer ?? props.carProductData.GPSOdometer ?? 0;
    }

    if (props.carProductData.CarControlType === controlType.None) {
      odometer += odometerBase;
    }

    const isMiles = isSiteUsingYards();
    if (isMiles) {
      const miles = Math.round(odometer);
      return `${miles} ${t(miles === 1 ? "Mile" : "Miles")}`;
    } else {
      const km = Math.round(convertMileToKM(odometer));
      return `${km} ${t(km === 1 ? "km" : "kms")}`;
    }
  };

  const getHrMeterDisplay = () => {
    if (!props.carProductData) return "";

    const hourMeterVal = props.clickState?.data?.DevType === deviceType.FT2
      ? props.carProductData.CarHistoryHourMeter
      : props.carProductData.HourMeter;

    const hrMeter = Math.round(hourMeterVal + (props.clickState?.data?.VirtualHourmeterBase ?? 0));
    return `${hrMeter} ${t(hrMeter === 1 ? "hour" : "hours")}`;
  };

  const getCarMakeModelWithYear = () => {
    const carInformation = props.clickState?.data;
    if (!carInformation) return "";

    const fullSerial = carInformation?.FullSerialNumber;
    const carMake = carInformation?.CarMake || "";
    const carModel = carInformation?.CarModel || "";

    if (fullSerial && fullSerial.length >= 2) {
      const startIndex = fullSerial.length === 12 ? 1 : 2;
      const endIndex = startIndex + 2;
      // prepend 20 to populate year in "YYYY" format
      const year = "20" + fullSerial.substring(startIndex, endIndex);
      return `${year} ${carMake} ${carModel}`.trim();
    }

    // Fallback to just make and model if serial number is not available
    return `${carMake} ${carModel}`.trim();
  };

  return (
    <HoverWindow style={{ position: "fixed", top: `${props.clickState.top}`, left: `${props.clickState.left}`}}>
      <div className="SignalIconCover">
        <SignalIcon width="16px" height="12.5px" color="gray" />
      </div>
      <div className="wrapper">
        <div className="close-icon-wrapper">
          <CloseIcon
            className="close-icon"
            onClick={() => props.setClickState({})}
          />
        </div>
        <div className="carSignalIcon">
          <h3>Car: {props.clickState?.data.CarNumber}</h3>
        </div>
        <div style={{ fontSize: 13, fontWeight: "bold" }}>
          {getCarMakeModelWithYear()}
        </div>
        <p>
          {moment
            .utc(props.clickState?.data.LastLocationUpdateInUtc)
            .utcOffset(siteSettingsData && -siteSettingsData?.TimeZoneOffset)
            .format("DD-MMM-YYYY, h:mm a")}
        </p>
        {props.clickState?.data.PlayerName1 !== null ? (
          <p>{props.clickState?.data.PlayerName1}</p>
        ) : (
          <></>
        )}
        {props.clickState.data.PlayerName2 !== null ? (
          <p>{props.clickState?.data.PlayerName2}</p>
        ) : (
          <></>
        )}

        <p>
          <span style={{ fontSize: 16 }}>
            {props.clickState?.data.HoleLocation === 0
              ? "Not playing"
              : props.clickState?.data.HoleLocation === 1
                ? `Hole ${props.clickState?.data.Hole} Between Holes `
                : props.clickState?.data.HoleLocation === 2
                  ? `Hole ${props.clickState?.data.Hole} Tee`
                  : props.clickState?.data.HoleLocation === 3
                    ? `Hole ${props.clickState?.data.Hole} Fairway`
                    : props.clickState?.data.HoleLocation === 4
                      ? `Hole ${props.clickState?.data.Hole} Green`
                      : ""}
          </span>
          <br />
        </p>
        <p style={{ fontSize: "16px" }}>
          {props?.getPaceString(props.clickState?.data)}
        </p>
        <p>
          {t("Report_Reason")}:
          {reasonForReportString(
            props.clickState?.data.LocationReasonForReport
          )}
        </p>
        <p>
          {t("GPRS_Signal")}:{props.clickState?.data.LocationGprsSignalStrength}{" "}
        </p>
        <p>
          {t("Sequence")} #:{props.clickState?.data.LocationSequenceNumber}{" "}
        </p>
        {props.carProductData && (
          <>
            <p style={{ fontWeight: "bold" }}>
              {t("Odometer")}: {getOdometerDisplay()}
            </p>
            <p style={{ fontWeight: "bold" }}>
              {t("Hour_Meter")}: {getHrMeterDisplay()}
            </p>
          </>
        )}
        <div className="icon-wrapper">
          <Tooltip title="Hide Location" arrow>
            <span
              onClick={hideLocation}
              className={
                showTaggedCar.get() === props.clickState?.data.CarNumber
                  ? "active"
                  : ""
              }
            >
              <LocationPointIcon color="var(--text-primary)" />
            </span>
          </Tooltip>
        </div>
      </div>
    </HoverWindow>
  );
};
